/**
 * BootStage.jsx
 *
 * Marks the current lifecycle stage on mount and wraps children in a
 * stage-scoped error boundary.
 */

import React, { useEffect } from 'react';
import { setBootStage } from '../lib/bootStage.js';
import BootErrorBoundary from './BootErrorBoundary.jsx';

export default function BootStage({ id, label, detail = null, children }) {
  useEffect(() => {
    setBootStage(id, label, detail);
  }, [id, label, detail]);

  return (
    <BootErrorBoundary stageId={id} stageLabel={label}>
      {children}
    </BootErrorBoundary>
  );
}
